export function immutablySwapItems<T>(items: T[], firstIndex: number, secondIndex: number): T[] {
  return items.map(function (element, index) {
    if (index === firstIndex) {return items[secondIndex];}
    else if (index === secondIndex) {return items[firstIndex];}
    else {return element;}
  });
}
